import setJwt from '@/api/middleware/setJwt'
import { getRequest, postRequestNoAuth } from '@/api/requests'
import { User } from '@/store/userStore'

interface LoginData {
  email: string
  password: string
}

export interface LoginResponse {
  token: string
  expiresOn: string
}

export const loginService = async (data: LoginData) => {
  const response = await postRequestNoAuth<LoginResponse>('/v1/auth/login', { ...data })
  if (response.status === 200) {
    setJwt(response.data as LoginResponse, true)
  }
  return response
}

export const userDetailsService = async () => {
  const response = await getRequest<User>('/v1/users/me', {})
  return response
}

export const logoutService = async () => {
  const response = getRequest('/v1/auth/logout', {})
  return response
}
